"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.propTypes = exports.defaultProps = exports.default = exports.ProductCardBody = void 0;
require("./ProductCardBody.css");
var _classnames = _interopRequireDefault(require("classnames"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Price = _interopRequireDefault(require("../Price/Price"));
var _ProductVariant = _interopRequireDefault(require("../ProductVariant/ProductVariant"));
var _Ratings = _interopRequireDefault(require("../Ratings/Ratings"));
var _Tag = _interopRequireDefault(require("../Tag/Tag"));
var _Text = _interopRequireDefault(require("../Text/Text"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
/**
 * ProductCardBody component
 *
 * @method
 * @param { ProductCardBodyProps} props
 * @returns ProductCardBody
 */

const ProductCardBody = props => {
  const {
    brandName,
    description,
    eyebrow,
    price,
    productVariant,
    ratings,
    secondValueTag,
    tag,
    tagsBottom,
    textAlign,
    title,
    titleSupport,
    valueTag
  } = props;
  const hasBrandName = brandName && brandName.text !== undefined;
  const hasDescription = description && description.text !== undefined;
  const hasPrice = price && (price.listPrice || price.kitPrice || price.salePrice || price.message);
  const hasProductVariant = productVariant && (productVariant.variantTypeLabel || productVariant.variantTypeDescription);
  const hasRatings = ratings && ratings.rating >= 0 && ratings.reviewsCount > 0;
  const hasTag = tag?.message || tag?.variant === 'urgency';
  const hasTitle = title && title.text !== undefined;
  const hasTagsArray = tagsBottom?.length > 0;
  const valueTagContent = valueTag || secondValueTag || hasTagsArray;

  // only render CardBody if any one of the body contents is passed as prop
  const hasContent = [hasBrandName, hasDescription, hasTag, hasTitle, titleSupport].some(Boolean);
  const componentClassName = (0, _classnames.default)('pal-c-ProductCardBody', {
    [`pal-c-ProductCardBody__textAlign--${textAlign}`]: textAlign
  });
  return /*#__PURE__*/_react.default.createElement("div", {
    className: componentClassName
  }, hasTag && /*#__PURE__*/_react.default.createElement("div", {
    className: "pal-c-ProductCardBody--tag"
  }, /*#__PURE__*/_react.default.createElement(_Tag.default, {
    backgroundColor: tag.backgroundColor,
    boldText: tag.boldText,
    endTime: tag.endTime,
    icon: tag.icon,
    message: tag.message,
    size: tag.size,
    startTime: tag.startTime,
    style: tag.style,
    textColor: tag.textColor,
    theme: tag.theme,
    timerMeta: tag.timerMeta,
    timerType: tag.timerType,
    variant: tag.variant
  })), eyebrow && /*#__PURE__*/_react.default.createElement(_Text.default, {
    textStyle: "eyebrow",
    htmlTag: "span",
    textAlign: textAlign
  }, eyebrow), hasContent && /*#__PURE__*/_react.default.createElement("div", {
    className: "pal-c-ProductCardBody--content"
  }, hasBrandName && /*#__PURE__*/_react.default.createElement("div", {
    className: "pal-c-ProductCardBody--brandName"
  }, /*#__PURE__*/_react.default.createElement(_Text.default, {
    textColor: brandName.textColor,
    textStyle: brandName.textStyle,
    htmlTag: brandName.tagName,
    textAlign: textAlign
  }, brandName.text)), hasTitle && /*#__PURE__*/_react.default.createElement("div", {
    className: "pal-c-ProductCardBody--title"
  }, /*#__PURE__*/_react.default.createElement(_Text.default, {
    textStyle: title.textStyle,
    htmlTag: title.tagName,
    textAlign: textAlign
  }, title.text)), titleSupport && /*#__PURE__*/_react.default.createElement(_Text.default, {
    textStyle: "body",
    htmlTag: "p",
    textAlign: textAlign
  }, titleSupport), hasDescription && /*#__PURE__*/_react.default.createElement("div", {
    className: "pal-c-ProductCardBody--description"
  }, /*#__PURE__*/_react.default.createElement(_Text.default, {
    textStyle: description.textStyle,
    htmlTag: "p",
    textAlign: textAlign
  }, description.text))), hasProductVariant && /*#__PURE__*/_react.default.createElement("div", {
    className: "pal-c-ProductCardBody--productVariant"
  }, /*#__PURE__*/_react.default.createElement(_ProductVariant.default, {
    externalMedia: productVariant.externalSwatchImage,
    swatchImage: productVariant.swatchImage,
    variantTypeLabel: productVariant.variantTypeLabel,
    variantTypeDescription: productVariant.variantTypeDescription
  })), hasRatings && /*#__PURE__*/_react.default.createElement("div", {
    className: "pal-c-ProductCardBody--ratings"
  }, /*#__PURE__*/_react.default.createElement(_Ratings.default, {
    rating: ratings.rating,
    maxRating: ratings.maxRating,
    reviewsCount: ratings.reviewsCount,
    variant: ratings.variant,
    reviewable: ratings.reviewable,
    reviewAccessibilityLabel: ratings.reviewAccessibilityLabel
  })), hasPrice && /*#__PURE__*/_react.default.createElement("div", {
    className: "pal-c-ProductCardBody--price"
  }, /*#__PURE__*/_react.default.createElement(_Price.default, {
    disabled: price.disabled,
    kitPrice: price.kitPrice,
    kitPriceAccessibilityLabel: price.kitPriceAccessibilityLabel,
    listPrice: price.listPrice,
    listPriceAccessibilityLabel: price.listPriceAccessibilityLabel,
    message: price.message,
    originalPriceLabel: price.originalPriceLabel,
    priceLabel: price.priceLabel,
    salePrice: price.salePrice,
    salePriceAccessibilityLabel: price.salePriceAccessibilityLabel,
    variant: price.variant
  })), valueTagContent && /*#__PURE__*/_react.default.createElement("div", {
    className: "pal-c-ProductCardBody--valueTags"
  }, valueTag && /*#__PURE__*/_react.default.createElement(_Tag.default, {
    variant: "value",
    message: valueTag,
    style: "default"
  }), secondValueTag && /*#__PURE__*/_react.default.createElement(_Tag.default, {
    variant: "value",
    message: secondValueTag,
    style: "default"
  }), hasTagsArray && tagsBottom.map((tagProps, index) => /*#__PURE__*/_react.default.createElement(_Tag.default, _extends({
    key: index
  }, tagProps)))));
};

/**
 * Property type definitions
 * @typedef ProductCardBodyProps
 * @type {object}
 * @property {object} brandName - Allows brandName prop to accept an object
 * @property {object} description - Basic text usually used as a description of the card
 * @property {string} eyebrow - Smaller text above the title
 * @property {string} linkType - sets the link type based on if the card is fully clickable
 * @property {object} price - Text for Price tag
 * @property {object} ratings - Allows ratings prop to accept an object
 * @property {string} secondValueTag - Text for the second value tag
 * @property {object} tag - Object for the tag
 * @property {string} textAlign - Where the text content should align horizontally
 * @property {object} title - Allows title prop to accept an object
 * @property {string} titleSupport - Support text for title
 * @property {string} valueTag - Text for value tag
 * @property {object} productVariant - Accepts product variant object to render ProductVariant component
 */
exports.ProductCardBody = ProductCardBody;
const propTypes = exports.propTypes = {
  /**
   * Allows brandName prop to accept an object
   * - ** text: ** Sets the text of the brandName
   * - ** tagName: ** Sets the HTML tag of the brandName oneOf( ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'] )
   * - ** titleStyle: ** Sets the style of the brandName oneOf( ['body-lg', 'body', 'body-sm', 'label', 'label-sm', 'title-xlg', 'title-lg', 'title', 'title-sm', 'headline-lg', 'headline', 'headline-sm', 'display-xlg', 'display-lg', 'display', 'display-sm', 'displayBody', 'displayBody-sm',] )
   */
  brandName: _propTypes.default.object,
  /**
   * Basic text usually used as a description of the card
   */
  description: _propTypes.default.object,
  /**
   * Smaller text above the title
   */
  eyebrow: _propTypes.default.string,
  /**
   * Object for Price
   *  - ** variant: **  Sets the variant for the Price oneOf(['default', 'PDP', 'large'])
   *  - ** listPrice: ** Sets the list price for the Price
   *  - ** listPriceAccessibilityLabel: ** Sets the list price accessibility label for screen readers
   *  - ** salePrice: **  Sets the sale price for the Price
   *  - ** salePriceAccessibilityLabel: ** Sets the sale price accessibility label for screen readers
   *  - ** kitPrice: **  Sets the kit price for the Price
   *  - ** kitPriceAccessibilityLabel: **  Sets the kit price accessibility label for screen readers
   *  - ** message: ** Sets the message to display when there is no price
   *  - ** disabled: ** Sets the disabled state for the price
   *  - ** priceLabel: ** Sets the price label to display
   *  - ** originalPriceLabel: ** Sets the original price text to display with list price
   */
  price: _propTypes.default.object,
  /**
   * Allows ratings prop to accept an object
   * - **rating:** Sets the Ratings stars
   * - **reviews:** Sets the reviews
   */
  ratings: _propTypes.default.object,
  /**
   * Text for the second value tag
   */
  secondValueTag: _propTypes.default.string,
  /**
   * Allows tag prop to accept an object
   * See tag component for more detail ../Tag/Tag.jsx
   */
  tag: _propTypes.default.object,
  /**
   * Where the text content should align horizontally
   * - ** left: **  left side of available space
   * - ** center: **  center of available space
   * - ** right: ** right of available space
   */
  textAlign: _propTypes.default.oneOf(['left', 'center', 'right']),
  /**
   * Allows title prop to accept an object
   * - ** text: ** Sets the title of the header
   * - ** children: ** Sets the children of the header
   * - ** tagName: ** Sets the HTML tag of the header oneOf( ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'] )
   * - ** titleStyle: ** Sets the style of the header oneOf( ['body-lg', 'body', 'body-sm', 'label', 'label-sm', 'title-xlg', 'title-lg', 'title', 'title-sm', 'headline-lg', 'headline', 'headline-sm', 'display-xlg', 'display-lg', 'display', 'display-sm', 'displayBody', 'displayBody-sm',] )
   */
  title: _propTypes.default.object,
  /**
   * Support text for title
   */
  titleSupport: _propTypes.default.string,
  /**
   * Text for value tag
   */
  valueTag: _propTypes.default.string,
  /**
   * Allows productVariant prop to accept an object
   * - ** externalSwatchImage: **  Sets the external swatch image
   * - ** swatchImage: ** Sets the palette swatch image
   * - ** variantTypeLabel: **  Sets the variant label coming from web-site
   * - ** variantTypeDescription: **  Sets the variant description coming from web-site (called variantLabel in web-site)
   */
  productVariant: _propTypes.default.object
};

/**
 * Default values for passed properties
 *
 * @type {object}
 * @property {object} description - textStyle:'body' - Sets the default description textStyle
 * @property {string} linkType - linkType: undefined - Sets the default value for the linkType oneOf('hiddenLink', 'textLink', 'noLink')
 * @property {string} textAlign='left' - set the default value for textAlign
 * @property {object} title - tagName: 'h2' & textStyle: 'title-lg' - set the default value tagName and textStyle for title
 */
const defaultProps = exports.defaultProps = {
  description: {
    textStyle: 'body'
  },
  linkType: undefined,
  textAlign: 'left',
  title: {
    tagName: 'h2',
    textStyle: 'title-lg'
  }
};
ProductCardBody.propTypes = propTypes;
ProductCardBody.defaultProps = defaultProps;
var _default = exports.default = ProductCardBody;